import React from "react";
import { Box, Typography, Button } from "@mui/material";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error in component tree:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ error: null });
  };

  render() {
    if (this.state.error) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          gap={2}
          p={4}
          minHeight="50vh"
        >
          <Typography variant="h5">Something went wrong.</Typography>
          <Typography variant="body2" color="text.secondary">
            {this.state.error.message || "An unexpected error occurred."}
          </Typography>
          <Box display="flex" gap={2}>
            <Button variant="outlined" onClick={this.handleReset}>
              Try again
            </Button>
            <Button
              variant="contained"
              onClick={() => window.location.assign("/")}
            >
              Go home
            </Button>
          </Box>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
